import {type FC, useEffect, useState} from 'react';
import {useLocation} from 'react-router';

import {Observer} from 'mobx-react';

import {Text} from '@yourcoach/shared/uikit/Text';

import type {LocationWithFromState} from '../../types';

import {BreadcrumbLink} from '../../components/BreadcrumbLink';
import {Layout} from '../../components/Layout';
import {BreadcrumbsStore} from '../../stores/Breadcrumbs';

type Props = {
  isWithCrumbs?: boolean;
  isWithFrom?: boolean;
  skipRootCrumb?: boolean;
};

export const BreadcrumbsContainer: FC<Props> = ({
  isWithCrumbs,
  isWithFrom,
  skipRootCrumb = false,
}) => {
  const location: LocationWithFromState = useLocation();

  const [store] = useState(
    () =>
      new BreadcrumbsStore({
        isWithCrumbs: Boolean(isWithCrumbs),
        isWithFrom: Boolean(isWithFrom),
        skipRoot: skipRootCrumb,
      }),
  );

  useEffect(() => {
    store.setSkipRoot(skipRootCrumb);
    store.nextLocation(location);
  }, [store, location, skipRootCrumb]);

  return (
    <Layout.Container>
      {isWithCrumbs ? (
        <Observer>
          {() => (
            <>
              {store.crumbs.map(crumb => (
                <Layout.Cell key={crumb.label}>
                  <BreadcrumbLink
                    className={({isActive}) => (isActive ? 'active' : '')}
                    end
                    state={{from: location.state?.from}}
                    to={{
                      pathname: crumb.path,
                    }}
                  >
                    <Text
                      color={'inherit'}
                      style={{
                        fontWeight: 'inherit',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {crumb.label}
                    </Text>
                  </BreadcrumbLink>
                </Layout.Cell>
              ))}
            </>
          )}
        </Observer>
      ) : null}
    </Layout.Container>
  );
};
